<template>
  <div class="status-col-filter full-width">
    <RDropdown
      :value="model"
      :options="options"
      :option-label="optionLabel"
      :option-value="optionValue"
      :multiple="multiple"
      :no-options-sort="noOptionsSort"
      :custom-has-value="!areAllOptionsSelected"
      placeholder="All"
      emit-value
      map-options
      no-label
      no-hint
      @input="valueChanged"
      @filtering-mode="filteringMode = $event"
    >
      <template v-if="multiple && !filteringMode" #before-options>
        <q-item clickable @click="handleAllOptionClick">
          <q-item-section side>
            <RCheckbox class="no-pointer-events" :value="areAllOptionsSelected" :val="null" />
          </q-item-section>

          <q-item-section>
            <q-item-label>All</q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </RDropdown>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      model: null,
      filteringMode: false
    }
  },

  computed: {
    filterInProgress() {
      const params = this.params.filterParams
      const filterInProgressModule = params.filterInProgressModule
      const filterInProgressState = params.filterInProgressState

      if (!filterInProgressModule || !filterInProgressState) return false

      return this.$store.state[filterInProgressModule][filterInProgressState]
    },

    multiple() {
      return !!this.params.filterParams.multiple
    },

    noOptionsSort() {
      return !!this.params.filterParams.noOptionsSort
    },

    customType() {
      return this.params.filterParams?.type || 'equals'
    },

    customFilterType() {
      return this.params.filterParams?.filterType || 'text'
    },

    options() {
      /*
       * - If you pass `options` in filterParams it will render those including the default option
       *
       * - If don't pass `options` but you pass a `optionsHandler` which should be a function,
       *   that function will be called with the shallow copy from Vuex state as argument
       *
       * - If you don't pass the above params, then options from Vuex state will be rendered including
       *   the default option
       * */
      const defaultOption = { [this.optionLabel]: 'All', [this.optionValue]: null }
      const params = this.params.filterParams

      if (params.options) return [defaultOption, ...params.options]

      const optionsModule = params.optionsModule
      const optionsState = params.optionsState
      const optionsFromVuex = [...this.$store.state[optionsModule][optionsState]]

      if (params.optionsHandler) return params.optionsHandler(optionsFromVuex)

      return [defaultOption, ...optionsFromVuex]
    },

    optionLabel() {
      if (this.params.filterParams.optionLabel) return this.params.filterParams.optionLabel
      return 'label'
    },

    optionValue() {
      if (this.params.filterParams.optionValue) return this.params.filterParams.optionValue
      return 'value'
    },

    areAllOptionsSelected() {
      if (!this.multiple) return ''
      return this.model.length === this.options.length
    }
  },

  watch: {
    multiple: {
      handler(newVal) {
        if (newVal) this.model = []
      },
      immediate: true
    },

    options: {
      handler(newVal) {
        if (this.multiple) this.model = newVal.map(opt => opt.value)
      },
      immediate: true
    }
  },

  methods: {
    handleAllOptionClick() {
      if (this.areAllOptionsSelected) this.valueChanged([])
      else this.valueChanged(this.options.map(o => o.value))
    },

    valueChanged(newValue) {
      if (this.filterInProgress) return

      this.model = newValue
      this.params.parentFilterInstance(instance => {
        instance.onFloatingFilterChanged(this.customType, newValue, this.customFilterType)
      })
    },

    onParentModelChanged(parentModel) {
      if (!parentModel) {
        if (this.multiple) this.model = []
        else this.model = null
      } else this.model = parentModel.filter
    }
  }
}
</script>
